import { InvitationRequest } from "@/types/Invitation";
import { makeAutoObservable } from "mobx";
import { RootStore } from "./RootStore";

export interface InvitationRequestLoading {
  state: "loading";
}

export interface InvitationRequestError {
  state: "error";
}

export interface InvitationRequestReady {
  state:
    | "ready"
    | "accepting"
    | "accept-error"
    | "accept-success"
    | "rejecting"
    | "reject-error"
    | "reject-success";
  data: InvitationRequest;
}

export type InvitationRequestState =
  | InvitationRequestLoading
  | InvitationRequestError
  | InvitationRequestReady;

export type BatchInvitationRequestState =
  | InvitationRequestLoading
  | InvitationRequestError
  | BatchInvitationRequestReady;

export interface BatchInvitationRequestReady {
  state:
    | "ready"
    | "accepting"
    | "accept-error"
    | "accept-success"
    | "rejecting"
    | "reject-error"
    | "reject-success";
  data: InvitationRequest[];
}

export default class InvitationRequestPageStore {
  invitationRequest: InvitationRequestState = { state: "loading" };

  constructor(
    private invitationRequestId: string,
    private rootStore: RootStore,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  *fetch() {
    try {
      this.invitationRequest = {
        data: yield this.rootStore.apiService.fetchInvitationRequest(this.invitationRequestId),
        state: "ready",
      };
    } catch (e) {
      this.invitationRequest = { state: "error" };
    }
  }

  *accept() {
    if (this.invitationRequest.state !== "ready") {
      return;
    }
    this.invitationRequest.state = "accepting";
    try {
      yield this.rootStore.apiService.acceptInvitationRequest(this.invitationRequestId);
      this.invitationRequest.state = "accept-success";
    } catch (e) {
      this.invitationRequest.state = "accept-error";
    }
  }

  *reject() {
    if (this.invitationRequest.state !== "ready") {
      return;
    }
    this.invitationRequest.state = "rejecting";
    try {
      yield this.rootStore.apiService.rejectInvitationRequest(this.invitationRequestId);
      this.invitationRequest.state = "reject-success";
    } catch (e) {
      this.invitationRequest.state = "reject-error";
    }
  }
}

export class BatchInvitationRequestPageStore {
  invitationRequest: BatchInvitationRequestState = { state: "loading" };

  constructor(
    private batchId: string,
    private rootStore: RootStore,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  *fetch() {
    try {
      this.invitationRequest = {
        data: yield this.rootStore.apiService.fetchBatchInvitationRequest(this.batchId),
        state: "ready",
      };
    } catch (e) {
      this.invitationRequest = { state: "error" };
    }
  }

  *accept() {
    if (this.invitationRequest.state !== "ready") {
      return;
    }
    this.invitationRequest.state = "accepting";
    try {
      yield this.rootStore.apiService.acceptBatchInvitationRequest(this.batchId);
      this.invitationRequest.state = "accept-success";
    } catch (e) {
      this.invitationRequest.state = "accept-error";
    }
  }

  *reject() {
    if (this.invitationRequest.state !== "ready") {
      return;
    }
    this.invitationRequest.state = "rejecting";
    try {
      yield this.rootStore.apiService.rejectBatchInvitationRequest(this.batchId);
      this.invitationRequest.state = "reject-success";
    } catch (e) {
      this.invitationRequest.state = "reject-error";
    }
  }
}
